import 'leaflet/dist/leaflet.css';
import { MapContainer, TileLayer, useMap } from 'react-leaflet';
import type { LatLngExpression } from 'leaflet';
import MarkerClusterGroup from 'react-leaflet-cluster';
import { useEffect } from 'react';

const defaultMapCenter: LatLngExpression = [37.0902, -95.7129];

// Updates center since MapContainer does not re-render when center prop changes
const UpdateMapCenter = ({ center }: { center: LatLngExpression }) => {
  const map = useMap();

  useEffect(() => {
    if (center) {
      map.setView(center);
    }
  }, [center, map]);

  return null;
};

export interface MapProps {
  children: React.ReactNode;
  mapCenter: LatLngExpression | undefined;
}

export const Map = ({ children, mapCenter }: MapProps) => {
  return (
    <MapContainer
      center={defaultMapCenter}
      className="h-[500px] w-full rounded-lg"
      zoom={5}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <MarkerClusterGroup chunkedLoading>{children}</MarkerClusterGroup>
      {mapCenter && <UpdateMapCenter center={mapCenter} />}
    </MapContainer>
  );
};

export default Map;
